import { render, staticRenderFns } from "./tabsHeader.vue?vue&type=template&id=308d8519&scoped=true&"
import script from "./tabsHeader.vue?vue&type=script&lang=js&"
export * from "./tabsHeader.vue?vue&type=script&lang=js&"
import style0 from "./tabsHeader.vue?vue&type=style&index=0&id=308d8519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d8519",
  null
  
)

component.options.__file = "tabsHeader.vue"
export default component.exports